import api from "./api";

export function saveDraft(data) {
  return api.post(`/drafts`, data);
}


export function getDraft(chatId) {
  return api.get(`/drafts/${chatId}`);
}


export function deleteDraft(chatId) {
  return api.delete(`/drafts/${chatId}`);
}


export function getAllDrafts() {
  return api.get(`/drafts/all`);
}
